export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:5000';
export const COPILOT_URL = process.env.REACT_APP_COPILOT_URL || 'http://localhost:8789';
/** Used when creating an instant meeting from Meetgeek (not via GetGeek). */
export const DEFAULT_COMPANY_ID = (process.env.REACT_APP_DEFAULT_COMPANY_ID || '').trim();

export const COLORS = {
  primary: '#9048fb',
  primaryDark: '#7b3fa0',
  primaryGradient: 'linear-gradient(135deg, #9048fb 0%, #7b3fa0 100%)',
  secondary: '#4285F4',
  secondaryHover: '#357ae8',
  success: '#4CAF50',
  successHover: '#45a049',
  successLight: '#E8F5E9',
  text: '#333333',
  textSecondary: '#666666',
  textTertiary: '#999999',
  textDark: '#ffffff',
  textSecondaryDark: 'rgba(255, 255, 255, 0.7)',
  textTertiaryDark: 'rgba(255, 255, 255, 0.5)',
  background: '#ffffff',
  backgroundDark: '#000000',
  backgroundGrey: '#f5f5f5',
  backgroundGreyDark: '#2a2a2a',
  backgroundGreyHover: '#3a3a3a',
  border: '#e0e0e0',
  borderLight: '#f0f0f0',
  borderDark: 'rgba(255, 255, 255, 0.1)',
  error: '#ff4444',
  overlay: 'rgba(17, 24, 39, 0.28)',
  overlayScrim: 'rgba(17, 24, 39, 0.28)',
  overlayDark: 'rgba(0, 0, 0, 0.7)',
};

export const Z_INDEX = {
  modal: 10001,
  shareModal: 10000,
  peopleModal: 10000,
  participantCount: 1000,
  button: 1000,
};

export const SPACING = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  xxl: '24px',
  xxxl: '32px',
  xxxxl: '40px',
};

export const BORDER_RADIUS = {
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  full: '50%',
  pill: '20px',
};

